import React, { useEffect } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import MediaQuery from 'react-responsive';
import {AccordionSummary} from "../theme/theme";
import { useMediaQuery } from 'react-responsive';

const VehiclesAccordion = ({
                               vehicleSegments, expandedSegment,
                               handleSegmentChange, t, vehiclesBySegment,
                               buildTile, filteredPriceRange, selectedSegments,
                               showDefaultSegment
                           }) => {
    const isMobileMax = useMediaQuery({ query: '(max-width: 479px)' });
    const [expanded, setExpanded] = React.useState(null);

    useEffect(() => {
        if (selectedSegments.length > 0) {
            setExpanded(vehicleSegments.filter(segments => selectedSegments.includes(segments) && vehiclesBySegment[segments].length)[0]);
        } else if (vehicleSegments.length > 0) {
            setExpanded(vehicleSegments[0]);
        }
    }, [vehicleSegments, selectedSegments]);

    const handleAccordionChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const renderAccordion = (id) => (
        <Accordion
            expanded={!isMobileMax ? expandedSegment.includes(id) : expanded === id}
            onChange={!isMobileMax ? handleSegmentChange(id) : handleAccordionChange(id)}
            elevation={0}
        >
            <AccordionSummary aria-controls="panel1d-content" id={id}>
                <div className={'segmentLabel'}>
                    <div className={'panel-heading'}>{t(id)}{showDefaultSegment(id)}</div>
                </div>
            </AccordionSummary>
            <AccordionDetails>
                {
                    <div className="vehicle-tiles-container">
                        {vehiclesBySegment[id].map(buildTile)}
                    </div>
                }
            </AccordionDetails>
        </Accordion>
    );

    const renderTiles = (id, index) => (
        <div key={`${id}-${index}`}>
            <div className={'panel-heading'}>{t(id)}</div>
            <div className="vehicle-tiles-container">
                {vehiclesBySegment[id].map(buildTile)}
            </div>
        </div>
    );

    const renderMobileAccordion = (id, index) => (
        <React.Fragment key={`${id}-${index}`}>
            <MediaQuery minWidth={480} maxWidth={899}>
                <div className={'mobileTabletAccordion'}>
                    {vehiclesBySegment[id] && !!vehiclesBySegment[id].length && expandedSegment && renderAccordion(id)}
                </div>
            </MediaQuery>
            {isMobileMax && (
                <div className={'mobileTabletAccordion'}>
                    {vehiclesBySegment[id] && !!vehiclesBySegment[id].length && expandedSegment && renderAccordion(id)}
                </div>
            )}
            <MediaQuery minWidth={900}>
                {!!vehiclesBySegment[id].length && <div className={'panel-heading'}>{t(id)}</div>}
                {
                    <div className="vehicle-tiles-container">
                        {vehiclesBySegment[id].map(buildTile)}
                    </div>
                }
            </MediaQuery>
        </React.Fragment>
    );

    const renderFilteredAccordion = (id, index) => (
        <div className={'mobileTabletAccordion'} key={`${id}-${index}`}>
            {isMobileMax ? (
                renderAccordion(id)
            ) : (
                <Accordion defaultExpanded={selectedSegments[0] === id} elevation={0}>
                    <AccordionSummary aria-controls="panel1d-content" id={id}>
                        <div className={'segmentLabel'}>
                            <div className={'panel-heading'}>{t(id)}</div>
                        </div>
                    </AccordionSummary>
                    <AccordionDetails>
                        <div className="vehicle-tiles-container">
                            {vehiclesBySegment[id].map(buildTile)}
                        </div>
                    </AccordionDetails>
                </Accordion>
            )}
        </div>
    );

    const showTile = vehicleSegments && vehicleSegments.map(renderMobileAccordion);

    const filteredTile = (
        <React.Fragment>
            <MediaQuery maxWidth={899}>
                {selectedSegments && selectedSegments.length ?
                    vehicleSegments && vehicleSegments.filter(segments => selectedSegments.includes(segments) && vehiclesBySegment[segments].length).map(renderFilteredAccordion) :
                    vehicleSegments && vehicleSegments.filter(segments => vehiclesBySegment[segments].length).map((id, index) => renderTiles(id, index))
                }
            </MediaQuery>
            <MediaQuery minWidth={900}>
                {selectedSegments && selectedSegments.length ?
                    vehicleSegments && vehicleSegments.filter(segments => selectedSegments.includes(segments) && vehiclesBySegment[segments].length).map((id, index) => renderTiles(id, index)) :
                    vehicleSegments && vehicleSegments.filter(segments => vehiclesBySegment[segments].length).map((id, index) => renderTiles(id, index))
                }
            </MediaQuery>
        </React.Fragment>
    );

    if (selectedSegments && selectedSegments.length === 0) {
        return showTile;
    } else if ((filteredPriceRange && filteredPriceRange.length > 1) || selectedSegments && selectedSegments.length > 1) {
        return filteredTile;
    }
}

export default VehiclesAccordion;